/**
 * LandingNav — the top navigation bar rendered by the landing page.
 *
 * Thin wrapper over the shared LandingNavBar primitives that injects the
 * landing-specific links (desktop + mobile variants).
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { landingTokens as T } from '@codex/theme';

import LanguageSwitcher from '../../../../components/LanguageSwitcher';
import {
  LandingNavBar,
  MobileNavLink,
  MobileNavRouterLink,
  MobileNavRouterLinkGold,
  MobileNavDivider,
  MobileNavCta,
  MobileNavSecondary,
} from '../../common/LandingNavBar';
import { LandingNavLink, LandingNavSignIn, LandingNavCta } from '../../common/LandingPage.styled';

export function LandingNav() {
  const { t } = useTranslation();

  return (
    <LandingNavBar
      mobileMenu={
        <>
          <MobileNavLink href="#features">{t('nav.features')}</MobileNavLink>
          <MobileNavLink href="#for-readers">{t('nav.readers')}</MobileNavLink>
          <MobileNavLink href="#pricing">{t('nav.pricing')}</MobileNavLink>
          <MobileNavRouterLink to="/referrals">{t('nav.referrals')}</MobileNavRouterLink>
          <MobileNavRouterLinkGold to="/pro">{t('nav.proLabel')}</MobileNavRouterLinkGold>
          <MobileNavDivider />
          <MobileNavCta to="/register">{t('nav.startWriting')}</MobileNavCta>
          <MobileNavSecondary to="/login">{t('nav.signIn')}</MobileNavSecondary>
        </>
      }
    >
      <LandingNavLink href="#features">{t('nav.features')}</LandingNavLink>
      <LandingNavLink href="#for-readers">{t('nav.readers')}</LandingNavLink>
      <LandingNavLink href="#pricing">{t('nav.pricing')}</LandingNavLink>
      {/* @ts-expect-error — styled.a doesn't forward react-router 'to' via 'as' prop */}
      <LandingNavLink as={Link} to="/referrals">
        {t('nav.referrals')}
      </LandingNavLink>
      <LandingNavSignIn to="/login">{t('nav.signIn')}</LandingNavSignIn>
      <LandingNavCta to="/register">{t('nav.startWriting')}</LandingNavCta>
      {/* @ts-expect-error — styled.a doesn't forward react-router 'to' via 'as' prop */}
      <LandingNavLink as={Link} to="/pro" style={{ color: T.gold }}>
        {t('nav.proLabel')}
      </LandingNavLink>
      <LanguageSwitcher variant="icon" sx={{ ml: 1 }} />
    </LandingNavBar>
  );
}

export default LandingNav;
